import api from "./api";

export const getFilialesList = async () => {
    const response = await api.get("/Filial/GetsList");

    return response.data.data;
}
